/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { useThemeMode } from "@/hooks/ui/design/use-theme-mode";
import React, { createContext, useContext } from "react";

type ThemeModeContextValue = ReturnType<typeof useThemeMode>;

const ThemeModeContext = createContext<ThemeModeContextValue | null>(null);

export function ThemeModeProvider({ children }: { children: React.ReactNode }) {
  const themeMode = useThemeMode();
  return (
    <ThemeModeContext.Provider value={themeMode}>
      {children}
    </ThemeModeContext.Provider>
  );
}

export function useThemeModeContext(): ThemeModeContextValue {
  const ctx = useContext(ThemeModeContext);
  if (!ctx) {
    throw new Error(
      "useThemeModeContext must be used within ThemeModeProvider",
    );
  }
  return ctx;
}
